import React from 'react';
import { LogOut } from 'lucide-react';
import Button from '../ui/Button';
import { useNavigate } from 'react-router-dom';
import PermissionGuard from '../PermissionGuard';
import { Permission } from '../../hooks/useRBAC';

interface DashboardHeaderProps {
	title?: string;
	description?: string;
	buttonLabel?: string;
	buttonLink?: string;
	buttonPermission?: Permission;
	onButtonAction?: () => void;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
	title = 'Verification Submissions',
	description = 'Manage identity verifications',
	buttonLabel = 'New Verification',
	buttonPermission = 'submissions.create',
	onButtonAction,
}) => {
	return (
		<div className="sticky right-0 z-50">
			<div className="mx-auto flex justify-between items-center">
				<div className="flex items-center gap-4">
					<div>
						<h1 className="text-2xl font-bold text-gray-900">{title}</h1>
						<p className="text-gray-600">{description}</p>
					</div>
				</div>
				<div className="flex items-center gap-3">
					<PermissionGuard permission={buttonPermission}>
						<Button onClick={onButtonAction} className="bg-ghana-red text-white hover:bg-red-700">
							{buttonLabel}
						</Button>
					</PermissionGuard>
				</div>
			</div>
		</div>
	);
};

export default DashboardHeader;
